export default __webpack_public_path__ + "static/media/bell-icon.b20d6a2e.svg";